import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useTitleActions(t, initial = {}) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState({ watchlist: !!initial.watchlist, watched: !!initial.watched });
  const needAuth = () => {
    if (user) return false;
    toast("Sign in to save titles", { description: "Create a free account to keep your watchlist on every device." });
    nav(`/login?next=${encodeURIComponent(window.location.pathname)}`);
    return true;
  };
  const toggle = async (kind) => {
    if (needAuth()) return;
    try {
      const { data } = await api.post(`/titles/${t.id}/${kind}`);
      setState((s) => ({ ...s, [kind]: data[kind] }));
      toast.success(kind === "watchlist" ? (data.watchlist ? "Added to your watchlist" : "Removed from watchlist") : (data.watched ? "Marked as watched" : "Removed from watched"));
    } catch (e) { toast.error(errMsg(e)); }
  };
  return { state, setState, toggle, needAuth };
}

export function TrailerModal({ trailerKey, onClose }) {
  if (!trailerKey) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4" onClick={onClose} data-testid="trailer-modal">
      <div className="aspect-video w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
        <iframe title="Official trailer" src={`https://www.youtube-nocookie.com/embed/${trailerKey}?autoplay=1&rel=0`} className="h-full w-full rounded-xl" allow="autoplay; encrypted-media" allowFullScreen />
        <button onClick={onClose} data-testid="trailer-close" className="mt-3 text-sm text-slate-300 hover:text-white">Close trailer</button>
      </div>
    </div>
  );
}
